// @flow
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import breakpoint from 'styled-components-breakpoint';

import { px, pr, py } from 'styled-components-spacing';

import theme from '@theme';

const { colors } = theme;

export const StyledWrapper = styled(Grid)`
  ${px(3)}
  ${py(2)}
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  color: ${colors.white};
  box-sizing: border-box;
  position: relative;
  ${breakpoint('desktop')`
  ${pr(0)}
  ${py(3)}
`}
  ${breakpoint('mobile', 'desktop')`
   ${px(0)};
  ${py(3)};`};
  ${breakpoint('largeDesktop')`
    max-width: 1500px;
    margin: 0 auto;
  `}
`;

export const StyledSearchUnit = styled(Grid.Unit)`
  display: flex;
  align-items: center;
  justify-content: center;
  ${breakpoint('desktop')`
  justify-content: flex-end;
`}
`;
